import React from "react";
import { InitialOfferSkeletonLoader, PageLayout } from "../../components";
import { useReuseVehicle } from "./useReuseVehicle";
import { Question } from "./Question";
import { MileageHelmet } from "../../components/SellHelmets";
import { useRecalcSavedDeal } from "./useRecalcSavedDeal";

export default function ReuseVehicle() {
  const recalculateSavedDealAppraisal =
    new URLSearchParams(window.location.search).get("journeyType") ===
    "reappraisal";
  const {
    useSameDetailsId,
    setUseSameDetailsId,
    model,
    derivative,
    registration,
    islocalAppraisalDataValid,
    startNewValuation,
    revisitAppraisals,
    loading
  } = useReuseVehicle(recalculateSavedDealAppraisal);

  useRecalcSavedDeal(recalculateSavedDealAppraisal);

  return (
    <>
      <MileageHelmet />
      <PageLayout>
        <PageLayout.Header title="Enter your mileage" step={1} />
        <PageLayout.Content backgroundColour={null}>
          {!islocalAppraisalDataValid || loading ? (
            <InitialOfferSkeletonLoader />
          ) : (
            <div>
              <div>
                <p className="ch-fs--4 ch-ma--0">
                  Do you want to use the details of this vehicle again?
                </p>
                <p className="ch-fs--2 ch-mb--4">
                  We saved the details from your last visit to save you time
                  when shopping online.{" "}
                </p>
                {registration && (
                  <div className="ch-card ch-mb--4  ">
                    <div className="ch-card__content ch-card__content--grey  mileage-card">
                      <div className="ch-display--flex ch-align-items--center">
                        {registration && (
                          <span className="ch-chip ch-chip--yellow ch-chip--lg">
                            {registration}
                          </span>
                        )}
                        <div className="ch-ml--2">
                          {model && (
                            <p className="ch-fs--3 ch-mb--0 ch-text--bold">
                              {model}
                            </p>
                          )}
                          {derivative && (
                            <p className="ch-fs--3 ch-mb--0">{derivative}</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <Question
                  useSameDetailsId={useSameDetailsId}
                  setUseSameDetailsId={setUseSameDetailsId}
                />
              </div>
            </div>
          )}
        </PageLayout.Content>
        {islocalAppraisalDataValid && (
          <PageLayout.Footer backgroundColour={null} position={null}>
            <button
              className="ch-btn ch-btn--success ch-display--block ch-mh--auto sm:ch-width--6 md:ch-width--5 ch-width--12 lg:ch-width--4"
              type="button"
              onClick={() =>
                useSameDetailsId === 1
                  ? revisitAppraisals()
                  : startNewValuation()
              }
            >
              Continue
            </button>
          </PageLayout.Footer>
        )}
      </PageLayout>
    </>
  );
}
